var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstructionsPressButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 123,
    viewBox: "0 0 96 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.7476 120.46L42.9842 116.342C39.2933 115.703 36.3312 112.449 36.369 109.064L37.0125 40.5918C37.0409 37.2161 40.0599 34.9876 43.7507 35.627L67.6561 37.4418C71.3469 38.0812 74.3091 41.3346 74.2712 44.7197L73.4857 115.496C73.4479 118.871 70.4384 121.1 66.7476 120.46Z",
    stroke: "#0000C2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.877 116.333C29.877 116.333 29.877 1.77676 29.877 0.394531L81.4637 5.54735",
    stroke: "#0000C2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4636 123C81.4636 123 81.4636 6.92018 81.4636 5.54735L95.8769 0.394531",
    stroke: "#0000C2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2965 49.3852L36.8611 41.6184C36.8611 41.6184 36.1324 36.4373 41.4983 35.5723L45.8422 35.7133C45.8422 35.7133 42.9463 37.876 44.3942 44.2042C44.3942 44.4957 58.5898 45.5018 58.5898 45.5018C58.5898 45.5018 58.1545 37.3024 61.4857 36.8699C60.757 37.3024 68.4416 37.5939 68.4416 37.5939C68.4416 37.5939 65.5457 42.3424 66.9936 45.6522C66.8517 45.6522 71.1955 45.0786 71.1955 45.0786L70.3248 114.877C70.3248 114.877 69.5961 118.911 64.9684 119.766L41.5078 116.024C41.5078 116.024 36.1513 114.294 36.2933 107.674C36.4258 107.674 37.2965 49.3852 37.2965 49.3852Z",
    fill: "#F8FFFB",
    stroke: "#0000C2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4935 85.4621C61.6813 84.6181 65.8348 77.6904 64.7707 69.9886C63.7066 62.2868 57.8278 56.7275 51.64 57.5714C45.4522 58.4154 41.2987 65.3431 42.3628 73.0449C43.4269 80.7467 49.3057 86.306 55.4935 85.4621Z",
    stroke: "#0000C2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1.30608 28.6799C2.08211 28.774 2.82028 28.191 2.90545 27.3917C3.35971 23.0476 5.03479 19.7941 7.86444 17.7255C12.5774 14.284 19.2777 14.9328 21.2367 15.2149V15.2243C21.1988 15.2525 21.1704 15.2713 21.1326 15.2995C19.8266 16.5125 18.5111 17.7255 17.2051 18.9385C16.6941 19.4086 16.6752 20.0198 17.1484 20.5276C17.2998 20.6968 17.4607 20.8567 17.6121 21.0259C18.0947 21.5337 18.7004 21.5619 19.2114 21.0823C21.5301 18.9385 23.8392 16.804 26.1484 14.6601C26.2241 14.5849 26.2998 14.5097 26.366 14.4157C26.6499 13.9831 26.5932 13.4942 26.2051 13.0898C24.3597 11.1152 22.5048 9.15 20.6594 7.17538C20.3471 6.83687 20.0348 6.50777 19.713 6.16926C19.2493 5.68971 18.6531 5.67091 18.161 6.11285C17.9812 6.30091 17.8014 6.47016 17.6215 6.63941C17.1389 7.09075 17.12 7.69254 17.5648 8.17209C18.5679 9.23463 19.5711 10.3066 20.5742 11.3691C20.8392 11.6512 21.1042 11.9333 21.407 12.253L21.2083 12.3C20.5742 12.2154 19.7225 12.1307 18.7193 12.1025C15.3313 11.9897 10.2398 12.4222 6.15151 15.3936C2.62154 17.9606 0.548986 21.9004 0.00955335 27.1002C-0.0756202 27.8901 0.501667 28.5953 1.30608 28.6799Z",
    fill: "#14E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6151 22.3329C48.4375 22.3329 50.7255 20.0596 50.7255 17.2553C50.7255 14.4511 48.4375 12.1777 45.6151 12.1777C42.7926 12.1777 40.5046 14.4511 40.5046 17.2553C40.5046 20.0596 42.7926 22.3329 45.6151 22.3329Z",
    fill: "white",
    stroke: "#0000C2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3848 22.0126C47.2072 22.0126 49.4952 19.7393 49.4952 16.935C49.4952 14.1307 47.2072 11.8574 44.3848 11.8574C41.5624 11.8574 39.2744 14.1307 39.2744 16.935C39.2744 19.7393 41.5624 22.0126 44.3848 22.0126Z",
    fill: "#14E6E6",
    stroke: "#0000C2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0252 11.7357L35.3091 9.44141",
    stroke: "#0000C2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6594 8.90532V5.53906",
    stroke: "#0000C2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7097 12.4025L54.1514 10.3809",
    stroke: "#0000C2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 123,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionsPressButton);
export default __webpack_public_path__ + "static/media/instructions_press_button.ccd8707e0c9aa77b46f175aa00dfd866.svg";
export { ForwardRef as ReactComponent };